function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  className: "FillColor",
  width: 1,
  height: 18,
  rx: 0.5,
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  className: "FillColor",
  x: 7,
  width: 1,
  height: 18,
  rx: 0.5,
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "FillColor",
  d: "M2 2C2 1.44772 2.44772 1 3 1H5C5.55228 1 6 1.44772 6 2V16C6 16.5523 5.55228 17 5 17H3C2.44772 17 2 16.5523 2 16V2Z",
  fill: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "FillColor",
  d: "M1 3H7V7H1V3Z",
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "FillColor",
  d: "M1 11H7V15H1V11Z",
  fill: "black"
});

var SvgStretcher = function SvgStretcher(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 18,
    viewBox: "0 0 8 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStretcher, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/stretcher.6ce284ca.svg";
export { ForwardRef as ReactComponent };